
import { TestState, overallStatus } from "../utils/common"

export interface SubElt {
    elt?: string;
    cls?: string;
    value: string | Array<eltbit>;
}

export type eltbit = string | SubElt;

export interface ConnectionTest {
    identifier: any
    status: TestState
    short?: string
    summary: eltbit[]
    details?: eltbit[][]
}

export interface ConnectionTestGroup {
    identifier: any
    running: boolean
    summary: eltbit[]
    subtests: Array<ConnectionTest | ConnectionTestGroup>
}

function groupComponentStatuses(g: ConnectionTestGroup): Array<{ status: TestState }> {
    return g.subtests.map( (st) => {
        if (st.hasOwnProperty('status')) {
            return st as ConnectionTest
        } else {
            return { status: groupStatus(st as ConnectionTestGroup) }
        }
    })
}

function groupStatus(g: ConnectionTestGroup): TestState {
    if (g.running) {
        return TestState.InProgress
    } else {
        return overallStatus(groupComponentStatuses(g))
    }
}

function eltDescription(elts: eltbit[]): string {
    let strings = elts.map(elt => {
        if (typeof(elt) === 'string') {
            return elt as string
        } else {
            let v = (elt as SubElt).value
            if (typeof(v) === 'string') {
                return v as string
            } else {
                return eltDescription(v as eltbit[])
            }
        }
    })
    return strings.join(" ")
}

export {
    groupStatus, groupComponentStatuses,
    eltDescription
}
